import 'hammerjs/hammer';